export default __webpack_public_path__ + "static/media/home2.a356fad6.png";